/**
 *  KeyBindingsFactory provides methods to create and destroy an instance of a <code>KeyBindings</code> object
 *
 *
 * @copyright Copyright 2016 The MathWorks, Inc.
 */

define([

    "mw-keybindings/KeyBindings"

], function (KeyBindings) {
    var _instance = null;

    /**
     * <code>KeyBindingsFactory</code> provides methods to create, access and destroy instances of KeyBindings.<br>
     *
     * @exports mw-keybindings/KeyBindingsFactory
     *
     */
    KeyBindingsFactory = {
        /**
         * This method returns the instance of a KeyBindings object
         * @param {actionDataService} actionDataService - loaded actionDataService provided
         *        to the KeyBindings API
         * @returns {object} An instance of a KeyBindings object
         */
        getInstance: function (actionDataService) {

                // if _instance isn't created then create it; otherwise return it
                if ( !_instance ) {
                    _instance = {
                        actionDataServiceUsed : actionDataService,
                        keyBindingsObject : new KeyBindings(actionDataService)
                    };
                }

                if(actionDataService !== _instance.actionDataServiceUsed) {
                    throw new Error("The keyBinding API is already registered with a different " +
                        "actionDataService, cannot use this actionDataService as an argument");
                }
                return _instance.keyBindingsObject;
        },

        /**
         * Destroy the KeyBindings instance
         */
        destroyInstance: function () {
            if(_instance){
                _instance.keyBindingsObject.cleanup();
                delete _instance.keyBindingsObject;
                 _instance = null;
            }
        }
    };

    return KeyBindingsFactory;
});